import PropTypes from 'prop-types'
import { translationPropType } from '../common/translation-prop-type'
import { externalLinkPropType } from './external-link-prop-type'

export const externalDataPropType = PropTypes.shape({
    data: PropTypes.arrayOf(
        PropTypes.arrayOf(
            PropTypes.shape({
                icon: PropTypes.number,
                name: translationPropType.isRequired,
                value: translationPropType
            })
        )
    ),
    externalLinks: PropTypes.shape({
        name: translationPropType,
        value: PropTypes.arrayOf(externalLinkPropType)
    }),
    title: translationPropType.isRequired,
    version: PropTypes.string.isRequired
})
